import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d54909c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = { class: "title header-title mt-3" }
const _hoisted_3 = { class: "input-group flex flex-column gap-2 mt-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "menu-title" }, [
  /*#__PURE__*/_createTextVNode("タイトル "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm ml-4" }, "※20文字以内")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block mt-5",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("グループカテゴリの設定 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm ml-4" }, "※いずれか1つを選択")
], -1))
const _hoisted_7 = { class: "col-8 d-flex justify-content-start pl-0" }
const _hoisted_8 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_9 = { class: "w-full mt-5 flex justify-content-center text-center flex-row align-items-center text-white" }
const _hoisted_10 = {
  key: 0,
  class: "pi pi-spin pi-spinner mr-2"
}

import { ref, onBeforeMount } from "vue";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { useStore } from "vuex";

import DistributionGroupService from "@/clinic/services/distribution_group_service";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicSetting',
  props: {
    isEdit: { type: Boolean },
    distributionGroupId: null,
    finalSetting: { type: Boolean },
    basicInformation: null
  },
  emits: ["saveBasicInformation"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  isEdit: boolean;
  distributionGroupId: any;
  finalSetting: boolean;
  basicInformation: {
    name: string;
    group_type: string;
  };
};





const store = useStore();
const clinicId = ref();

const isLoading = ref(false);
const basicInformationErrors = ref({});
const groupName = ref(props.basicInformation?.name);
const groupType = ref(props.basicInformation?.group_type);

const previousPage = () => {
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUP_ROUTER_NAME);
};

const setGroupType = type => {
  groupType.value = type;
};

const onSaveBasicInformation = async () => {
  try {
    isLoading.value = true;
    const params = { clinic_id: clinicId.value };
    const body = { group_type: groupType.value, name: groupName.value };
    let response;

    if (props.distributionGroupId) {
      response = await DistributionGroupService.updateBasicInformation(props.distributionGroupId, params, body);
    } else {
      response = await DistributionGroupService.createBasicInformation(params, body);
    }

    isLoading.value = false;
    emits("saveBasicInformation", 2, response);
  } catch (error: any) {
    basicInformationErrors.value = error.response.data.errors;
    isLoading.value = false;
  }
};

const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};

onBeforeMount(async () => {
  await loadClinicInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: _normalizeClass(["mb-5 border-round-lg mt-5", { 'pointer-events-none': props.finalSetting }])
  }, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(props.isEdit ? "配送グループの編集" : "新規配信グループの作成"), 1)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputText, {
          id: "menu-title",
          class: "p-float-label flex border-round-md border-200 w-9",
          placeholder: "タイトルテキスト",
          modelValue: groupName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((groupName).value = $event))
        }, null, 8, ["modelValue"]),
        (basicInformationErrors.value?.name)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(basicInformationErrors.value.name[0]), 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          label: "新規向け",
          class: _normalizeClass(["mr-2 target-button", { 'bg-custom': groupType.value === 'new_user' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setGroupType('new_user')))
        }, null, 8, ["class"]),
        _createVNode(_component_Button, {
          label: "再来向け",
          class: _normalizeClass(["mr-2 target-button", { 'bg-custom': groupType.value === 're_examination' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setGroupType('re_examination')))
        }, null, 8, ["class"]),
        _createVNode(_component_Button, {
          label: "既存向け",
          class: _normalizeClass(["mr-2 target-button", { 'bg-custom': groupType.value === 'existing' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setGroupType('existing')))
        }, null, 8, ["class"]),
        _createVNode(_component_Button, {
          label: "一斉配信",
          class: _normalizeClass(["mr-2 target-button", { 'bg-custom': groupType.value === 'broadcast_all_in_one' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (setGroupType('broadcast_all_in_one')))
        }, null, 8, ["class"]),
        _createVNode(_component_Button, {
          label: "その他",
          class: _normalizeClass(["mr-2 target-button", { 'bg-custom': groupType.value === 'other_type' }]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (setGroupType('other_type')))
        }, null, 8, ["class"])
      ]),
      (basicInformationErrors.value?.group_type)
        ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(basicInformationErrors.value.group_type[0]), 1))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (props.finalSetting == false)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, {
                type: "button",
                class: "p-button-light mb-8 mr-5",
                label: "キャンセル",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (previousPage()))
              }),
              _createVNode(_component_Button, {
                type: "button",
                class: "btn-primary btn-save mb-8 w-3",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (onSaveBasicInformation()))
              }, {
                default: _withCtx(() => [
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                    : _createCommentVNode("", true),
                  _createTextVNode("作成に進む ")
                ]),
                _: 1
              })
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["class"]))
}
}

})